import Typography from "@mui/material/Typography";
import { useStyles } from "./RemainingCharacterCounter.styles";
import { IRemainingCharacterCounter } from "./RemainingCharacterCounterInterfaces";

export const RemainingCharacterCounter = ({ maxLength, value }: IRemainingCharacterCounter) => {
    const remainingCharacters = maxLength - value.length;
    const classes = useStyles();

    return (
        <Typography className={classes.remainingCharacterCount} variant="h6">
            {value.length}/{remainingCharacters}
        </Typography>
    );
};
